import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import Messenger from '../../tnew/ui/Messenger';


function getErrorMessage() {
  const key = ComponentKeys.PAYMENT_PLANS;

  return ContentStorage.get(key, 'PaymentPlanErrorMessage');
}


class PaymentPlanErrorMessage {
  /**
   * @param {HTMLElement} $messageContainer
   */
  constructor($messageContainer) {
    this.messenger = new Messenger($messageContainer);
  }

  show() {
    this.messenger.addErrorMessage(getErrorMessage());
  }

  hide() {
    this.messenger.clearMessages();
  }
}


export default PaymentPlanErrorMessage;
